<template>
  <div style="background: #D8D8D8;width:100%;height:146px;">
 
    <el-image 
    style="max-height:100%;"
    :src="photo.FileUrl" 
    fit="fill"
    :preview-src-list="[photo.FileUrl]">
  </el-image>
  </div>
</template>
<script>
export default {
  props:{
    photo:{
      type:Object,
      default:{

      }
    }
  },
  data() {
    return {};
  },
};
</script>
